const Ovision = () => {
return(
    <section className="Ovision">
        <div className="relative md:h-[500px] h-full overflow-hidden">
        <div
            className="absolute inset-0 bg-fixed bg-center bg-cover"
            style={{ backgroundImage: `url(https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755622230/bg-black_qhktrk.jpg)` }}
        ></div>
        <div className="relative z-10 flex items-center justify-center h-full bg-black bg-opacity-40 md:px-0 md:py-0 px-10 py-20">
            <div className="md:w-1/5 relative h-96">
                <img src="https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621359/quote-lt_zdyaub.png" alt="left quote" className="absolute top-0 left-10 w-40 h-auto"/>
            </div>
            <div className="md:w-1/2 text-left">
                <p className="text-white text-blck md:text-1xl text-left">
                At Springdales The School, we envision a nurturing environment where every child is inspired to explore their unique talents and interests. We strive to foster a community of lifelong learners who are curious, confident, and compassionate.Our goal is to empower young minds to reach their full potential, instilling a love for learning that lasts a lifetime. We believe in cultivating creativity, critical thinking, and collaboration among our students, preparing them to be responsible and engaged citizens in a diverse world.Together with our families and community, we are committed to creating a safe and inclusive space where every child feels valued and supported, setting the foundation for a bright future.
                </p>
            </div>
            <div className="md:w-1/5 relative h-96">
                <img src="https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621362/quote-rt_hmjvsi.png" alt="right quote" className="absolute bottom-0 left-10 w-40 h-auto"/>
            </div>
        </div>
       </div>
    </section>
);
};

export default Ovision;